import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    glass?: boolean;
    hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
    children,
    className = '',
    glass = false,
    hover = false,
}) => {
    return (
        <div className={`card ${glass ? 'glass' : ''} ${hover ? 'card-hover' : ''} ${className}`}>
            {children}
        </div>
    );
};
